/* Golf bet calculators — DOM wiring for sections/golf-bet-calculator.liquid,
   which serves three pages from one scorecard: skins, a Nassau and Wolf.
   All the rules live in golf-bets-engine.js (window.WGBets); shared helpers
   in wg-calc.js.
   The card is saved in this browser as it is typed (localStorage, one slot
   per game), so a locked phone or a reload mid-round loses nothing.
   Events (snippets/wg-tracking.liquid):
     wg_bets_settle {label: game + players, value: holes played}   once per distinct settled card
     wg_bets_example {label: game}                                 "Load the example round"
     wg_bets_app_click {label: game}                               the app button (data-track) */
(function () {
  'use strict';

  var LETTERS = ['A', 'B', 'C', 'D', 'E', 'F'];
  var GAMES = {
    skins: { players: [2, 3, 4, 5, 6], start: 4, stake: 'Skin value', unit: 'a skin' },
    nassau: { players: [2, 4], start: 2, stake: 'Stake on each bet', unit: 'a bet' },
    wolf: { players: [3, 4, 5], start: 4, stake: 'Value of a point', unit: 'a point' }
  };

  function init(root) {
    var G = window.WGBets;
    var C = window.WGCalc;
    if (!G || !C) return;
    var game = GAMES[root.dataset.game] ? root.dataset.game : 'skins';
    var spec = GAMES[game];
    var STORE = 'wg-bets-' + game;

    var q = function (sel) { return root.querySelector(sel); };
    var qa = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };
    var el = {
      form: q('[data-form]'),
      count: qa('[data-count]'),
      names: q('[data-names]'),
      stake: q('[data-stake]'),
      stakeHint: q('[data-stake-hint]'),
      scoring: qa('[data-scoring]'),
      netNote: q('[data-net-note]'),
      payout: qa('[data-payout]'),
      carry: qa('[data-carry]'),
      leftover: q('[data-leftover]'),
      playoffField: q('[data-playoff-field]'),
      playoff: q('[data-playoff]'),
      presses: qa('[data-presses]'),
      manual: q('[data-manual]'),
      manualList: q('[data-manual-list]'),
      addPress: q('[data-add-press]'),
      lastHoles: qa('[data-last-holes]'),
      card: q('[data-card]'),
      cardHint: q('[data-card-hint]'),
      example: q('[data-example]'),
      clear: q('[data-clear]'),
      heading: q('[data-result-heading]'),
      summary: q('[data-summary]'),
      balances: q('[data-balances]'),
      pay: q('[data-pay]'),
      detail: q('[data-detail]'),
      detailTitle: q('[data-detail-title]'),
      inline: q('[data-inline]')
    };
    var text = { example: root.dataset.hExample, result: root.dataset.hResult };

    var state = fresh();
    var lastTracked = '';

    function fresh() {
      var s = {
        n: spec.start,
        names: [],
        stake: '',
        net: false,
        handicaps: [],
        si: [],
        scores: [],
        calls: [],
        payout: 'each',
        carry: true,
        leftover: 'none',
        playoff: -1,
        presses: 'none',
        manual: [],
        lastHoles: 'fewest'
      };
      for (var p = 0; p < 6; p++) {
        s.names.push('');
        s.handicaps.push('');
        s.scores.push(blankRow());
      }
      for (var h = 0; h < G.HOLES; h++) { s.si.push(''); s.calls.push(''); }
      return s;
    }
    function blankRow() {
      var row = [];
      for (var h = 0; h < G.HOLES; h++) row.push('');
      return row;
    }

    function save() {
      try { window.localStorage.setItem(STORE, JSON.stringify(state)); } catch (e) { /* storage blocked: fine */ }
    }
    function restore() {
      try {
        var saved = JSON.parse(window.localStorage.getItem(STORE) || 'null');
        if (!saved || typeof saved !== 'object' || !Array.isArray(saved.scores)) return;
        var base = fresh();
        Object.keys(base).forEach(function (k) { if (saved[k] !== undefined && typeof saved[k] === typeof base[k]) base[k] = saved[k]; });
        if (spec.players.indexOf(base.n) === -1) base.n = spec.start;
        state = base;
      } catch (e) { /* unreadable: start clean */ }
    }

    /* ---------- names ---------- */

    // While the example round is on the card, players go by its letters.
    var alias = null;

    function sidesFor(n) {
      return n === 4 ? [[0, 1], [2, 3]] : [[0], [1]];
    }
    function sides() {
      return sidesFor(alias ? alias.length : state.n);
    }
    function name(p) {
      if (alias) return 'Player ' + alias[p];
      var typed = (state.names[p] || '').trim();
      return typed || 'Player ' + LETTERS[p];
    }
    function short(p) {
      if (alias) return alias[p];
      var typed = (state.names[p] || '').trim();
      return typed ? typed.slice(0, 10) : LETTERS[p];
    }
    function sideName(i) {
      var side = sides()[i];
      return side.map(short).join(' + ');
    }
    function placeholder(p) {
      if (game === 'nassau' && state.n === 4) return 'Team ' + (p < 2 ? '1' : '2') + ', player ' + LETTERS[p];
      return 'Player ' + LETTERS[p];
    }

    /* ---------- building the form ---------- */

    function buildNames() {
      el.names.textContent = '';
      for (var p = 0; p < state.n; p++) {
        var field = C.el('div', 'wgc__field bets__player');
        var id = 'bets-name-' + game + '-' + p;
        var label = C.el('label', 'wgc__label', placeholder(p));
        label.setAttribute('for', id);
        var input = C.el('input', 'wgc__input');
        input.id = id;
        input.type = 'text';
        input.maxLength = 14;
        input.autocomplete = 'off';
        input.placeholder = 'Name';
        input.value = state.names[p];
        input.setAttribute('data-name', p);
        field.appendChild(label);
        field.appendChild(input);
        if (state.net) {
          var hc = C.el('input', 'wgc__input bets__hc');
          hc.type = 'text';
          hc.inputMode = 'numeric';
          hc.maxLength = 2;
          hc.autocomplete = 'off';
          hc.placeholder = 'Course handicap';
          hc.setAttribute('aria-label', 'Course handicap for ' + name(p));
          hc.value = state.handicaps[p];
          hc.setAttribute('data-hc', p);
          field.appendChild(hc);
        }
        el.names.appendChild(field);
      }
    }

    function cell(tag, className, textValue) {
      return C.el(tag, className, textValue);
    }
    function scoreInput(attr, value, label, max) {
      var input = C.el('input', 'bets__score');
      input.type = 'text';
      input.inputMode = 'numeric';
      input.maxLength = max || 2;
      input.autocomplete = 'off';
      input.value = value;
      input.setAttribute('aria-label', label);
      Object.keys(attr).forEach(function (k) { input.setAttribute(k, attr[k]); });
      return input;
    }

    function callOptions(select, h, wolf) {
      var keep = state.calls[h];
      select.textContent = '';
      var first = C.el('option', null, 'Call');
      first.value = '';
      select.appendChild(first);
      for (var p = 0; p < state.n; p++) {
        if (p === wolf) continue;
        var o = C.el('option', null, 'With ' + short(p));
        o.value = 'p' + p;
        select.appendChild(o);
      }
      [['lone', 'Lone wolf'], ['blind', 'Blind wolf']].forEach(function (x) {
        var o2 = C.el('option', null, x[1]);
        o2.value = x[0];
        select.appendChild(o2);
      });
      // The Wolf cannot take the Wolf, and a partner who has left the game is gone.
      select.value = keep;
      if (select.value !== keep) { select.value = ''; state.calls[h] = ''; }
    }

    function buildCard() {
      el.card.textContent = '';
      var table = C.el('table', 'wgc__table bets__table');
      // Columns that stay on the top line of a hole on a phone: the scores,
      // and the stroke index when the game is net.
      table.style.setProperty('--bets-cols', String(state.n + (state.net ? 1 : 0)));
      var thead = C.el('thead');
      var tr = C.el('tr');
      tr.appendChild(cell('th', null, 'Hole'));
      if (state.net) {
        // The full name where there is room, the abbreviation on a phone.
        var si = cell('th', 'bets__si-head');
        si.appendChild(cell('span', 'bets__long', 'Stroke index'));
        var abbr = cell('abbr', 'bets__short', 'SI');
        abbr.title = 'Stroke index';
        si.appendChild(abbr);
        tr.appendChild(si);
      }
      for (var p = 0; p < state.n; p++) {
        var th = cell('th', null, short(p));
        th.setAttribute('data-head', p);
        tr.appendChild(th);
      }
      if (game === 'wolf') {
        tr.appendChild(cell('th', 'bets__below-head', 'Wolf'));
        tr.appendChild(cell('th', 'bets__below-head', 'Call'));
      }
      tr.appendChild(cell('th', 'bets__below-head bets__result-head', 'Result'));
      thead.appendChild(tr);
      table.appendChild(thead);

      var tbody = C.el('tbody');
      for (var h = 0; h < G.HOLES; h++) {
        var row = C.el('tr');
        row.setAttribute('data-row', h);
        if (h === 9) row.className = 'bets__turn';
        var head = cell('th', null, String(h + 1));
        head.scope = 'row';
        row.appendChild(head);
        if (state.net) {
          var siCell = cell('td');
          siCell.appendChild(scoreInput({ 'data-si': h }, state.si[h], 'Stroke index, hole ' + (h + 1)));
          row.appendChild(siCell);
        }
        for (var i = 0; i < state.n; i++) {
          var td = cell('td');
          td.appendChild(scoreInput({ 'data-score': i + ':' + h }, state.scores[i][h], name(i) + ', hole ' + (h + 1)));
          row.appendChild(td);
        }
        if (game === 'wolf') {
          var who = cell('td', 'bets__wolf');
          who.setAttribute('data-wolf', h);
          row.appendChild(who);
          var callCell = cell('td', 'bets__call-cell');
          var select = C.el('select', 'bets__call');
          select.setAttribute('data-call', h);
          select.setAttribute('aria-label', 'The Wolf’s call on hole ' + (h + 1));
          callCell.appendChild(select);
          row.appendChild(callCell);
        }
        var result = cell('td', 'bets__result');
        result.setAttribute('data-result', h);
        row.appendChild(result);
        tbody.appendChild(row);
      }
      table.appendChild(tbody);
      el.card.appendChild(table);
    }

    function buildManual() {
      if (!el.manualList) return;
      el.manualList.textContent = '';
      state.manual.forEach(function (press, i) {
        var row = C.el('div', 'bets__press');
        var from = C.el('select', 'wgc__select bets__press-from');
        from.setAttribute('data-press-from', i);
        from.setAttribute('aria-label', 'Press ' + (i + 1) + ' starts on hole');
        for (var h = 2; h <= 18; h++) {
          if (h === 10) continue;
          var o = C.el('option', null, 'From hole ' + h);
          o.value = String(h);
          from.appendChild(o);
        }
        from.value = String(press.from);
        var by = C.el('select', 'wgc__select bets__press-by');
        by.setAttribute('data-press-by', i);
        by.setAttribute('aria-label', 'Press ' + (i + 1) + ' called by');
        [0, 1].forEach(function (s) {
          var o2 = C.el('option', null, 'Called by ' + sideName(s));
          o2.value = String(s);
          by.appendChild(o2);
        });
        by.value = String(press.by);
        var remove = C.el('button', 'wgc__btn wgc__btn--quiet bets__press-remove', 'Remove');
        remove.type = 'button';
        remove.setAttribute('data-press-remove', i);
        row.appendChild(from);
        row.appendChild(by);
        row.appendChild(remove);
        el.manualList.appendChild(row);
      });
    }

    function buildPlayoff() {
      if (!el.playoff) return;
      el.playoff.textContent = '';
      var none = C.el('option', null, 'Not played yet');
      none.value = '-1';
      el.playoff.appendChild(none);
      for (var p = 0; p < state.n; p++) {
        var o = C.el('option', null, name(p));
        o.value = String(p);
        el.playoff.appendChild(o);
      }
      el.playoff.value = String(state.playoff);
      if (el.playoff.value !== String(state.playoff)) { el.playoff.value = '-1'; state.playoff = -1; }
    }

    // Puts the state into every control that is not rebuilt from it.
    function syncControls() {
      el.count.forEach(function (c) { c.checked = parseInt(c.value, 10) === state.n; });
      el.stake.value = state.stake;
      el.scoring.forEach(function (c) { c.checked = (c.value === 'net') === state.net; });
      el.payout.forEach(function (c) { c.checked = c.value === state.payout; });
      el.carry.forEach(function (c) { c.checked = (c.value === 'on') === state.carry; });
      if (el.leftover) el.leftover.value = state.leftover;
      el.presses.forEach(function (c) { c.checked = c.value === state.presses; });
      el.lastHoles.forEach(function (c) { c.checked = c.value === state.lastHoles; });
    }

    // A name changed: relabel the card without touching the input in use.
    function rename() {
      qa('[data-head]').forEach(function (th) { th.textContent = short(parseInt(th.getAttribute('data-head'), 10)); });
      qa('[data-hc]').forEach(function (hc) { hc.setAttribute('aria-label', 'Course handicap for ' + name(parseInt(hc.getAttribute('data-hc'), 10))); });
      buildManual();
      buildPlayoff();
    }

    function rebuild() {
      syncControls();
      buildNames();
      buildCard();
      buildManual();
      buildPlayoff();
    }

    /* ---------- reading the card ---------- */

    function numbers() {
      var scores = [];
      for (var p = 0; p < state.n; p++) {
        scores.push(state.scores[p].map(function (v) {
          var n = C.num(v, { integer: true });
          return G.isScore(n) ? n : NaN;
        }));
      }
      return scores;
    }

    // Net scores when the card has what they need; otherwise says what is missing.
    function scored() {
      var gross = numbers();
      if (!state.net) return { scores: gross, problem: '' };
      var handicaps = [];
      for (var p = 0; p < state.n; p++) {
        var h = C.num(state.handicaps[p], { integer: true });
        if (isNaN(h) || h > 54) return { scores: null, problem: 'Enter a course handicap for every player, a whole number from 0 to 54.' };
        handicaps.push(h);
      }
      var si = state.si.map(function (v) { return C.num(v, { integer: true }); });
      if (!G.validStrokeIndexes(si)) {
        return { scores: null, problem: 'Enter the stroke index for every hole from the scorecard. Each number from 1 to 18 is used once.' };
      }
      var allowance = game === 'nassau' && state.n === 4 ? 0.9 : 1;
      return {
        scores: G.netScores(gross, { handicaps: handicaps, strokeIndexes: si, allowance: allowance }),
        playing: G.playingHandicaps(handicaps, allowance),
        problem: ''
      };
    }

    function calls() {
      return state.calls.map(function (c) {
        if (c === 'lone' || c === 'blind') return { type: c };
        if (/^p\d$/.test(c)) return { type: 'partner', partner: parseInt(c.slice(1), 10) };
        return null;
      });
    }

    function stake() {
      var v = C.num(state.stake);
      return isNaN(v) ? NaN : v;
    }

    /* ---------- results ---------- */

    // How much of a hole has been typed: 'none', 'some' or 'all' of the scores.
    function typed(h, n) {
      var count = 0;
      for (var p = 0; p < n; p++) if (String(state.scores[p][h]).trim() !== '') count += 1;
      return count === 0 ? 'none' : count === n ? 'all' : 'some';
    }
    // What a hole that has been started is still waiting for.
    function waiting(h, n, needsCall) {
      var have = typed(h, n);
      if (have === 'some') return 'Waiting for every score';
      if (have === 'all' && needsCall) return 'Pick the Wolf\u2019s call';
      return '';
    }

    function setResult(h, message, kind) {
      var td = el.card.querySelector('[data-result="' + h + '"]');
      if (!td) return;
      td.textContent = message || '';
      td.className = 'bets__result' + (kind ? ' bets__result--' + kind : '');
    }

    function row(label, value, modifier) {
      var r = C.el('div', 'wgc__eq-row' + (modifier ? ' wgc__eq-row--' + modifier : ''));
      r.appendChild(C.el('span', 'wgc__eq-label', label));
      r.appendChild(C.el('span', 'wgc__eq-num', value));
      return r;
    }

    function drawMoney(balances, players, hasStake) {
      el.balances.textContent = '';
      players.forEach(function (p) {
        var r = row(name(p), hasStake ? G.signed(balances[p]) : 'n/a');
        var num = r.querySelector('.wgc__eq-num');
        if (hasStake && balances[p] > 0) num.classList.add('wgc__eq-num--gain');
        if (hasStake && balances[p] < 0) num.classList.add('wgc__eq-num--loss');
        el.balances.appendChild(r);
      });
      el.pay.textContent = '';
      if (!hasStake) {
        el.pay.appendChild(C.el('li', 'bets__pay-none', 'Enter what you are playing for to see who pays whom.'));
        return;
      }
      var pay = G.settle(players.map(function (p) { return balances[p]; }));
      if (!pay.length) {
        el.pay.appendChild(C.el('li', 'bets__pay-none', 'All square. Nobody owes anybody.'));
        return;
      }
      pay.forEach(function (x) {
        var li = C.el('li', 'bets__pay-row');
        li.appendChild(C.el('span', null, name(players[x.from]) + ' pays ' + name(players[x.to])));
        li.appendChild(C.el('strong', null, G.money(x.amount)));
        el.pay.appendChild(li);
      });
    }

    function plural(n, word) {
      return G.count(n) + ' ' + word + (n === 1 ? '' : 's');
    }

    // Each of these settles one game. o is the set of house rules; paint
    // says whether to write the hole-by-hole results onto the card.
    function computeSkins(scores, value, o, paint) {
      var r = G.skins(scores, { players: o.n, carryover: o.carry, leftover: o.leftover,
        playoffWinner: o.playoff, value: isNaN(value) ? 0 : value, payout: o.payout });
      var played = 0;
      var lastPlayed = -1;
      r.holes.forEach(function (h, i) { if (h.played) lastPlayed = i; });
      r.holes.forEach(function (h, i) {
        if (h.played) played += 1;
        if (!paint) return;
        if (!h.played) setResult(i, waiting(i, o.n, false), 'todo');
        else if (h.winner !== null) setResult(i, short(h.winner) + ' wins ' + h.atStake, 'win');
        else if (!h.carried) setResult(i, 'Tied, no skin');
        else if (i === lastPlayed) setResult(i, 'Tied, ' + plural(h.atStake, 'skin') + ' left over');
        else setResult(i, 'Tied, next hole worth ' + (h.atStake + 1));
      });

      var detail = [];
      for (var p = 0; p < o.n; p++) detail.push([name(p), plural(r.skins[p], 'skin')]);
      if (o.payout === 'pot' && !isNaN(value) && r.total > 0) {
        detail.push(['Pot, ' + plural(r.total, 'skin') + ' at ' + G.money(Math.round(value * 100)), G.money(r.pot), 'total']);
        detail.push(['Each player puts in', G.money(r.ante)]);
      }
      var note = '';
      if (r.unclaimed > 0) {
        var it = r.unclaimed === 1 ? 'it' : 'them';
        note = plural(r.unclaimed, 'skin') + (r.unclaimed === 1 ? ' was' : ' were') + ' still riding after the last hole played' +
          (o.leftover === 'playoff' ? '. Pick the playoff winner to award ' + it + '.' : ', so nobody won ' + it + '.');
      } else if (r.leftover.skins > 0 && r.leftover.to.length) {
        note = plural(r.leftover.skins, 'skin') + ' left riding ' + (o.leftover === 'split' ? 'split between ' : 'went to ') +
          r.leftover.to.map(name).join(' and ') + '.';
      }
      return { played: played, balances: r.balances, note: note, title: 'Skins won', detail: detail,
        headline: plural(r.total, 'skin') + ' won over ' + plural(played, 'hole') + '.' };
    }

    function computeNassau(scores, value, o, paint) {
      var r = G.nassau(scores, { sides: sidesFor(o.n), stake: isNaN(value) ? 0 : value, presses: o.presses, manual: o.manual });
      var played = 0;
      var front = 0;
      var back = 0;
      r.results.forEach(function (res, i) {
        if (res === null) { if (paint) setResult(i, waiting(i, o.n, false), 'todo'); return; }
        played += 1;
        var step = res === 0 ? 1 : res === 1 ? -1 : 0;
        var lead;
        if (i < 9) { front += step; lead = front; } else { back += step; lead = back; }
        if (!paint) return;
        var hole = res === -1 ? 'Halved' : sideName(res) + (sidesFor(o.n)[res].length > 1 ? ' win' : ' wins');
        var nine = (i < 9 ? 'Front: ' : 'Back: ') + (lead === 0 ? 'all square' : sideName(lead > 0 ? 0 : 1) + ' ' + Math.abs(lead) + ' up');
        setResult(i, hole + '. ' + nine, res === -1 ? '' : 'win');
      });

      var won = [0, 0];
      var pushed = 0;
      var live = 0;
      var detail = r.bets.map(function (b) {
        if (b.status === 'won') won[b.winner] += 1;
        else if (b.status === 'push') pushed += 1;
        else live += 1;
        return [b.name + (b.kind === 'press' ? ', holes ' + b.from + ' to ' + b.to : ''),
          b.status === 'live' ? 'In play' : b.status === 'push' ? 'All square' : sideName(b.winner) + ', ' + b.margin];
      });
      var bits = [sideName(0) + ' won ' + plural(won[0], 'bet'), sideName(1) + ' won ' + plural(won[1], 'bet')];
      if (pushed) bits.push(pushed + ' finished all square');
      if (live) bits.push(live + ' still in play');
      return { played: played, balances: r.balances, title: 'The bets', detail: detail,
        note: !isNaN(value) && value > 0 ? G.money(r.inPlay) + ' in play across ' + plural(r.bets.length, 'bet') + '.' : '',
        headline: bits.join(', ') + '.' };
    }

    function wolfResult(h) {
      if (h.result === 'push') return 'Push';
      var each = 0;
      h.collected.forEach(function (c) { if (c > each) each = c; });
      if (h.result === 'others') return 'The others win, ' + each + ' each';
      if (h.call === 'partner') return short(h.wolf) + ' + ' + short(h.partner) + ' win, ' + each + ' each';
      return short(h.wolf) + ' wins ' + each + (h.call === 'blind' ? ', blind' : ', alone');
    }

    function computeWolf(scores, value, o, paint) {
      var r = G.wolf(scores, { players: o.n, stake: isNaN(value) ? 0 : value, lastHoles: o.lastHoles, calls: o.calls });
      var played = 0;
      r.holes.forEach(function (h, i) {
        if (h.played) played += 1;
        if (!paint) return;
        var who = el.card.querySelector('[data-wolf="' + i + '"]');
        if (who) who.textContent = short(h.wolf) + (h.byFewest ? ' (fewest)' : '');
        var select = el.card.querySelector('[data-call="' + i + '"]');
        var made = h.wolf + ':' + o.n + ':' + namesKey();
        if (select && select.getAttribute('data-for') !== made) {
          callOptions(select, i, h.wolf);
          select.setAttribute('data-for', made);
        }
        if (h.played) setResult(i, wolfResult(h), h.result === 'wolf' ? 'win' : '');
        else setResult(i, waiting(i, o.n, !state.calls[i]), 'todo');
      });

      var detail = [];
      for (var p = 0; p < o.n; p++) {
        detail.push([name(p) + ', ' + r.collected[p] + ' collected', (r.net[p] > 0 ? '+' : r.net[p] < 0 ? '−' : '') + Math.abs(r.net[p]) + ' net']);
      }
      var top = 0;
      for (var x = 1; x < o.n; x++) if (r.collected[x] > r.collected[top]) top = x;
      return { played: played, balances: r.balances, title: 'Points', detail: detail,
        note: 'Money follows the net: every loser pays every winner a point, doubled on a blind wolf.',
        headline: name(top) + ' collected the most, ' + r.collected[top] + ' points over ' + plural(played, 'hole') + '.' };
    }

    function namesKey() {
      return state.names.slice(0, state.n).join('|');
    }

    function settleGame(scores, value, o, paint) {
      if (game === 'nassau') return computeNassau(scores, value, o, paint);
      if (game === 'wolf') return computeWolf(scores, value, o, paint);
      return computeSkins(scores, value, o, paint);
    }

    // The round from our guide, settled the way the guide settles it, at the
    // guide's stake until the visitor types their own.
    function exampleRound(value) {
      var ex = G.EXAMPLES[game];
      var at = !isNaN(value) && value > 0 ? value : (ex.stake || ex.value);
      alias = ex.names;
      var out = settleGame(ex.scores, at, {
        n: ex.names.length, carry: true, leftover: 'none', playoff: -1, payout: 'pot',
        presses: 'manual', manual: ex.manual || [], lastHoles: 'fewest', calls: ex.calls || []
      }, false);
      out.value = at;
      return out;
    }

    function drawCard(out, value) {
      el.detailTitle.textContent = out.title;
      el.detail.textContent = '';
      out.detail.forEach(function (d) { el.detail.appendChild(row(d[0], d[1], d[2])); });
      var players = [];
      for (var p = 0; p < out.balances.length; p++) players.push(p);
      drawMoney(out.balances, players, !isNaN(value) && value > 0);
    }

    function compute() {
      var value = stake();
      var stakeTyped = state.stake.trim() !== '';
      var stakeBad = stakeTyped && (isNaN(value) || value <= 0 || value > 10000);
      el.stake.classList.toggle('wgc__input--bad', stakeBad);
      C.setHint(el.stakeHint, stakeBad ? 'Enter an amount in dollars, like 5 or 2.50.' : '', stakeBad);
      if (stakeBad) value = NaN;

      if (el.netNote) el.netNote.hidden = !state.net;
      if (el.playoffField) el.playoffField.hidden = state.leftover !== 'playoff' || !state.carry;
      if (el.leftover) el.leftover.disabled = !state.carry;
      if (el.manual) el.manual.hidden = state.presses !== 'manual';

      var s = scored();
      C.setHint(el.cardHint, s.problem, !!s.problem);
      var rules = { n: state.n, carry: state.carry, leftover: state.carry ? state.leftover : 'none', playoff: state.playoff,
        payout: state.payout, presses: state.presses, manual: state.manual, lastHoles: state.lastHoles, calls: calls() };
      // With the net details missing nothing can be scored, but the card still
      // needs its Wolf column and its calls.
      var out = settleGame(s.scores || numbers().map(function (r) { return r.map(function () { return NaN; }); }), value, rules, true);

      var empty = out.played === 0;
      root.classList.toggle('bets--empty', empty);
      if (s.problem) {
        el.heading.textContent = text.result;
        el.summary.textContent = s.problem;
        el.detailTitle.textContent = out.title;
        el.detail.textContent = '';
        el.balances.textContent = '';
        el.pay.textContent = '';
        el.pay.appendChild(C.el('li', 'bets__pay-none', 'Net scores need every course handicap and every stroke index before the round can be settled.'));
      } else if (empty) {
        var ex = exampleRound(value);
        el.heading.textContent = text.example;
        el.summary.textContent = 'The round from our guide, at ' + G.money(Math.round(ex.value * 100)) + ' ' + spec.unit + '. ' + ex.headline +
          (game === 'wolf' ? ' Type your own scores and calls to settle your round.' : ' Type your own scores to settle your round.');
        drawCard(ex, ex.value);
        alias = null;
      } else {
        el.heading.textContent = text.result;
        el.summary.textContent = out.headline + (out.note ? ' ' + out.note : '');
        drawCard(out, value);
      }
      el.inline.textContent = '';
      return out;
    }

    function track(out) {
      if (!out || !out.played) return;
      var key = [game, state.n, out.played, out.balances.join(',')].join('|');
      if (key === lastTracked) return;
      lastTracked = key;
      C.track('bets_settle', { label: game + ', ' + state.n + ' players', value: String(out.played), element: root });
    }

    /* ---------- events ---------- */

    function loadExample() {
      var ex = G.EXAMPLES[game];
      var keep = state.names.slice();
      state = fresh();
      state.names = keep;
      state.n = ex.names.length;
      state.stake = String(ex.stake || ex.value);
      ex.scores.forEach(function (rowScores, p) { state.scores[p] = rowScores.map(String); });
      if (game === 'skins') state.payout = 'pot';
      if (game === 'nassau') { state.presses = 'manual'; state.manual = ex.manual.map(function (m) { return { from: m.from, by: m.by }; }); }
      if (game === 'wolf') state.calls = ex.calls.map(function (c) { return c.type === 'partner' ? 'p' + c.partner : c.type; });
      rebuild();
      track(compute());
      save();
      C.track('bets_example', { label: game, element: root });
    }

    function clearCard() {
      var keep = { names: state.names.slice(), n: state.n, stake: state.stake };
      state = fresh();
      state.names = keep.names;
      state.n = keep.n;
      state.stake = keep.stake;
      rebuild();
      compute();
      save();
    }

    // After a score that cannot grow into a two-digit number, move on.
    function advance(input) {
      if (!/^[2-9]$/.test(input.value) && input.value.length < 2) return;
      var all = qa('[data-score]');
      var i = all.indexOf(input);
      if (i !== -1 && all[i + 1]) all[i + 1].focus();
    }

    el.form.addEventListener('input', function (e) {
      var t = e.target;
      if (t.hasAttribute('data-score')) {
        t.value = t.value.replace(/[^\d]/g, '');
        var at = t.getAttribute('data-score').split(':');
        state.scores[parseInt(at[0], 10)][parseInt(at[1], 10)] = t.value;
        var n = C.num(t.value, { integer: true });
        t.classList.toggle('bets__score--bad', t.value !== '' && !G.isScore(n));
        compute();
        advance(t);
      } else if (t.hasAttribute('data-si')) {
        t.value = t.value.replace(/[^\d]/g, '');
        state.si[parseInt(t.getAttribute('data-si'), 10)] = t.value;
        compute();
      } else if (t.hasAttribute('data-hc')) {
        t.value = t.value.replace(/[^\d]/g, '');
        state.handicaps[parseInt(t.getAttribute('data-hc'), 10)] = t.value;
        compute();
      } else if (t.hasAttribute('data-name')) {
        state.names[parseInt(t.getAttribute('data-name'), 10)] = t.value;
      } else if (t === el.stake) {
        t.value = t.value.replace(/[^\d.,]/g, '');
        state.stake = t.value;
        compute();
      }
      save();
    });

    el.form.addEventListener('change', function (e) {
      var t = e.target;
      var again = false;
      if (t.hasAttribute('data-count')) { state.n = parseInt(t.value, 10); state.manual = []; again = true; }
      else if (t.hasAttribute('data-scoring')) { state.net = t.value === 'net'; again = true; }
      else if (t.hasAttribute('data-name')) rename();
      else if (t.hasAttribute('data-payout')) state.payout = t.value;
      else if (t.hasAttribute('data-carry')) state.carry = t.value === 'on';
      else if (t === el.leftover) state.leftover = t.value;
      else if (t === el.playoff) state.playoff = parseInt(t.value, 10);
      else if (t.hasAttribute('data-presses')) state.presses = t.value;
      else if (t.hasAttribute('data-last-holes')) state.lastHoles = t.value;
      else if (t.hasAttribute('data-call')) state.calls[parseInt(t.getAttribute('data-call'), 10)] = t.value;
      else if (t.hasAttribute('data-press-from')) state.manual[parseInt(t.getAttribute('data-press-from'), 10)].from = parseInt(t.value, 10);
      else if (t.hasAttribute('data-press-by')) state.manual[parseInt(t.getAttribute('data-press-by'), 10)].by = parseInt(t.value, 10);

      if (again) rebuild();
      var out = compute();
      save();
      track(out);
    });

    el.form.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('button') : null;
      if (!t) return;
      if (t === el.addPress) {
        state.manual.push({ from: 4, by: 1 });
        buildManual();
      } else if (t.hasAttribute('data-press-remove')) {
        state.manual.splice(parseInt(t.getAttribute('data-press-remove'), 10), 1);
        buildManual();
      } else if (t === el.example) {
        loadExample();
        return;
      } else if (t === el.clear) {
        clearCard();
        return;
      } else return;
      track(compute());
      save();
    });
    el.form.addEventListener('submit', function (e) { e.preventDefault(); });

    restore();
    rebuild();
    compute();
  }

  if (window.WGCalc) window.WGCalc.boot('[data-wgc-bets]', init);
})();
